import { render, staticRenderFns } from "./SuspendedDrivers.html?vue&type=template&id=2b223585&scoped=true&external"
import script from "./SuspendedDrivers.js?vue&type=script&lang=js&external"
export * from "./SuspendedDrivers.js?vue&type=script&lang=js&external"
import style0 from "./SuspendedDrivers.vue?vue&type=style&index=0&id=2b223585&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b223585",
  null
  
)

export default component.exports